// config.artlaindustrial.js
  /*
   BATX i CICLES (Noel, Reme)

   nomSentit

   plaIndividualitzat

   poblacioNaixement
   provinciaNaixement
   paisNaixement
   nacionalitat
   idalu

   informacioExtraEstudisPrevis
   certificatProvaAccessFile


   authIntranet: Filmacions destinades a difusió pública no comercial
   authMaterialNomCognoms
   authMaterialExposat
   authInternet
   authSortidaEsbarjo
   authSortidaHorari
   authDanys

  */

const textInscripcioText = () =>  {

  //return (<>CONSULTEU LA <a href="http://www.inscavallbernat.cat/" target="_blank" rel="noreferrer">PÀGINA WEB DE L'INSTITUT CAVALL BERNAT</a> PER INFORMAR-VOS DEL MATERIAL I ELS LLIBRES QUE NECESSITEU PER INICIAR EL CURS</>)
  return (<></>)

}

const config =
{
  cid: 'a8042354',

  // llistat dels camps d'autorització del pas "Protecció de dades" d'aquest centre
  // (veure src/components/enrolmentform/authorizations/artlaindustrial/)
  autoritzacions: [
    'authCompromis', 'authDanys', 'authGDPR', 'authImatgeProhibicions', 'authInternet',
    'authIntranet', 'authMaterial', 'authMaterialExposat', 'authMaterialInicials',
    'authMaterialNomCognoms', 'authMedica', 'authPortatils', 'authPublicacions',
    'authQuota', 'authResponsable', 'authSortidaEsbarjo', 'authSortidaHorari', 'authSortides',
  ],

  phone: "933 21 90 66",
  email: "a8042354@xtec.cat",

  headerLogo: 'img/logo_bn_artlaindustrial.png',
  headerTitle: "Escola d'Art La Industrial",
  headerURL: 'https://matricula.artlaindustrial.cat/',

  //enrollmentPostURL: 'https://matricula.artlaindustrial.cat/post/',
  enrollmentPostURL: '/post/',
  //apiURL: 'https://matricula.artlaindustrial.cat/api/',
  apiURL: '/api/',

  popupInicial: true,

  /* valor per defecte (mandatori); es pot sobreescriure per curs concret amb
     curs.adjuntarArxiusNoObligatori a les dades de families (chkiddoc + cursObligatori);
     aquest valor només s'aplica a la matrícula lliure, sense curs obligatori */
  adjuntarArxiusNoObligatori: false,

  // llibre de família (plana progenitors + plana alumne) obligatori per als menors d'edat
  llibreFamiliaObligatori: false,

  validaIDdocuments: true,
  validaIDdocumentsFalsePermetMatricular: true,
  tipusDocTSI: true,

  nomSentit: true,

  fotoCarnet: true,
  validaIAfotoCarnetFile: true,

  telefonObligatori: true,
  carnetFamiliaNombrosa: false,

  contacteEmergenciaObligatori: true,

  adjuntMedic: true,
  adjuntMedicObligatori: false,

  //datesNoBloquejenInscripcio: false,
  datesNoBloquejenInscripcio: false,

  noPreguntarSiEsNouAlumne: false,

  notesAcces: true,

  // mostra CFGM, CFGS i BATX en una sola columna
  ciclesEncolumnats: true,

  mostraTorns: false,

  logo: 'img/logo_artlaindustrial.jpg',
  titol: "Escola d'Art La Industrial",

  favicon: '/img/favicon-artlaindustrial.ico',
  faviconGestio: '/gestio/img/favicon-artlaindustrial.ico',

  assignatures: 'assignatures/assignatures.artlaindustrial.json',
  families: 'families/families.artlaindustrial.json',
  dadesbancaries: 'dadesbancaries/dadesbancaries.artlaindustrial.json',
  calculquota: 'quotes.artlaindustrial.json',

  /* camps especifics per centre */
  treballantFile: true,
  necessitatsEducativesEspecials: true,

  informacioExtraEstudisAcces: true,

  repetidor: true,
  repetidorsNoPodenAgafarAssignaturesDe2n: false,

  textDadesMediquesAlgunSi: "",

  textBotoMatricular: "INSCRIURE",

  proporcionarPreinscripcioNous: true,
  proporcionarTitolPreinscripcioNous: true,

  textAlumneNouAlCentre: "Ets alumne/a nou/nova al nostre centre?",
  textAlumneNouAlCentreSub: null,

  urlTPV: "https://matricula.artlaindustrial.cat/tpv/",
  pagamentTPV: true,
  // un cop feta la inscripció, si hi ha import a pagar, redirigeix directament a la
  // passarel·la de pagament sense mostrar cap pantalla intermèdia
  redireccioAutomaticaTPV: true,
  pagamentTransferencia: false,

  textInscripcioText: null,

  /* el pagament en dos terminis només està habilitat durant el primer periòde de matriculacions */
  dosTerminisEnabled: (new Date().getMonth() >= 4 && new Date().getMonth() <= 7),
  /* si es fals mostrem unes altres condicions de pagament */
  dosTerminisEnabledFalseCondicio: 0,

  sexeNoBinari: true,

  pattern_batx_nocturn: /^BATXLOE\d{5}N[A-Z]{1,2}$/,
  pattern_1r_batx: /^BATXLOE\d{4}1[^N][A-Z]{1,2}$/,
  pattern_2n_batx: /^BATXLOE\d{4}2[^N][A-Z]{1,2}$/,

  su: [ "WyIxMTExMTExMU", "giLCIyMjIyMjIy", "MkoiLCIzMzMzMz", "MzM1AiLCI0NDQ0", "NDQ0NEEiLCI1NT", "U1NTU1NUsiLCI2", "NjY2NjY2NlEiLC", "I3Nzc3Nzc3N0Ii", "LCI4ODg4ODg4OF", "kiLCI5OTk5OTk5", "OVIiLCIxMDExMT", "ExMUwiLCIxMjIy", "MjIyMVoiLCIxMz", "MzMzMzMkQiLCIx", "NDQ0NDQ0M0ciLC", "IxNTU1NTU1NEUi", "LCIxNjY2NjY2NV", "YiLCIxNzc3Nzc3", "Nk4iLCIxODg4OD", "g4N0YiLCIxOTk5", "OTk5OFciLCIyMT", "ExMTEwOUMiLCIy", "MjIyMjIyMFMiLC", "IyMzMzMzMzMVgi", "LCIyNDQ0NDQ0Mk", "0iLCIyNTU1NTU1", "M1QiLCIyNjY2Nj", "Y2NEgiLCIyNzc3", "Nzc3NUoiXQo="],
};

export default  config;